import React, { useEffect } from 'react'
import { required, TextInput, TextInputProps } from 'react-admin'
import { TEMPORARYREQUEST_FIELDS } from '../../../providers/localization/constant'
import { useFormContext, useWatch } from 'react-hook-form'

const defaultProps = {
  label: `${TEMPORARYREQUEST_FIELDS}.cancel_reason.choices.other`,
  source: 'action_type',
}

export const TextInputCancelReason: React.FC<TextInputProps> = ({ label, source, ...props }) => {
  const depField = 'action_type'
  const expectedValue = 'other'

  const fieldCond = useWatch({ name: depField })
  const { unregister } = useFormContext()
  const validator = {
    validate: [required()],
  }

  useEffect(() => {
    if (fieldCond !== expectedValue) {
      unregister(source)
    }
  }, [fieldCond, source, unregister])
  if (!depField) return null

  return fieldCond === expectedValue ? (
    <TextInput
      source={source}
      label={label}
      InputProps={{
        fullWidth: true,
      }}
      fullWidth
      {...(fieldCond === expectedValue ? validator : '')}
      {...props}
    />
  ) : null
}

TextInputCancelReason.defaultProps = defaultProps
